import React from 'react';
import Icon from '@ant-design/icons/lib/components/Icon';
import GuuruSvg from './GuuruFilled.svg';

// eslint-disable-next-line react/require-default-props
const GuuruFilled = function (props: React.ComponentProps<typeof Icon>) {
  return (
    <Icon component={GuuruSvg} {...props} />
  );
};

export default GuuruFilled;
